
export type GetCourseReviewsSortOrder = typeof GetCourseReviewsSortOrder[keyof typeof GetCourseReviewsSortOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseReviewsSortOrder = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
